<template>
  <div id="latelyFile">
    <div class="fileHead">
      <div class="title"> 
        <span></span>
         最近打开的文件
      </div>
      <div class="clear" @click="clear">清空</div>
    </div>
    <div class="contain" @scroll="handleScroll">
      <div class="files">
      <div class="fileCol" :title="item.fileName" v-for="(item,index) in fileList" :key="index"  @click.stop="clickFolderFile(item, $event)">
        <img class="fileIcon" :src="className(item)">
        <p class="fileName">{{item.fileName}}</p>
      </div>
      <div class="hasMore" v-show="fileLoading">
        <i class="el-icon-loading"></i>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/xgzdService/project-service.js'
import { noLabelFilePreview, recentdoctableRowIcon } from "@/CommonDP/utils/docPublic";
import { mapState } from "vuex";
export default {
  data() {
    return {
      fileList:[],
      pageNum: 1,
      pageSize: 40,
      totalPage: 1,
      fileLoading: false
    };
  },
   computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
  },
  watch: {
    pageNum: {
      handler() {
        this.getFileList()
      },
      immediate: true
    }
  },
  methods: {
    async getFileList() {
      this.fileLoading = true
      const { pageSize, pageNum} = this
      let enterpriseId = this.enterpriseId;
      let res = await request.getuserRecentViewFile(pageNum,pageSize,enterpriseId).catch(
        err => {
          console.error('获取最近打开文件失败')
        }
      );
      this.totalPage = res?.totalPage || 1
      if (Array.isArray(res?.data)) {
        if(this.pageNum == 1 && res?.data.length == 0){
          this.fileList = []
        }else{
          this.fileList = this.fileList.concat(res.data)
        }
      }
      this.fileLoading = false
    },
    className(row) {
      return recentdoctableRowIcon(row);
    },
    clickFolderFile(row) {
      // 预览
      var row1={
        folderId:row.fileId,
        folderName:row.fileName,
        fileVersion:row.fileVersion,
        prjId:row.prjId,
        fileType:Number(row.fileType),
        status:row.status.toString()
      };
      if(row.prjId==='EnterpriseDoc'||row.prjId==='MyDoc'){
        // 需要隐藏
        noLabelFilePreview(row1, row.prjId, '', "ct",true);
      }else{
        noLabelFilePreview(row1, row.prjId, '', "ct",'');
      }
    },
    handleScroll(event) {
      const target = event.target
      if (!target) return
      const biasHeight = 20 // 设置偏差20px
      const height = target.scrollHeight
      const clientHeight = target.clientHeight
      const top = target.scrollTop
      const { pageNum, totalPage } = this
      if ((height - top < clientHeight + biasHeight) && pageNum < totalPage) {
        if (!this.fileLoading) {
          this.$nextTick(() => {
            this.pageNum += 1
          })
        }
      }
    },
    clear() {
      request.clearRecentView().then(res => {
        if(res.result == 0) {
          this.$message.success('操作成功')
          this.pageNum = 1;
          this.getFileList()
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
#latelyFile{
  width: 100%;
  height: 100%;
  min-width: 350px;
  box-sizing: border-box;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(231, 235, 239, 0.25);
  border-radius: 3px;
  .fileHead{
    height: 50px;
		line-height: 50px;
    padding: 0 16px;
		border-bottom: 1px solid #E5E8F1;
    .title{
      font-weight: 700;
      font-size: 16px;
      line-height: 50px;
      color: #323232;
      float: left;
      span{
        display: inline-block;
        width: 3px;
        height: 15px;
        background: #5584FF;
        border-radius: 8px;
      }
    }
    .clear{
      float: right;
      color: #5584FF;
      cursor: pointer;
    }
    .moreBtn{
      font-size: 16px;
      float: right;
      color: #6C7682;
    }
  }
  .fileCol{
    cursor: pointer;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    width: 100%;
    align-items: center;
    gap: 4px;
  }
  .contain{
    width: 100%;
    height: calc(100% - 50px);
    overflow: hidden auto;
   
  }
  .files {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    overflow: hidden auto;
    padding: 10px;
    justify-content: center;
    box-sizing: border-box;

  }
  .fileIcon{
    height: 20px;
    width: 20px;
  }
  .fileName {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
  }
}
</style>
